export default (props = {}) => <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<g id="vuesax/linear/danger">
<g id="danger">
<path id="Vector" d="M14.5 10.5V16.3333" stroke="#AF1F24" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector_2" d="M14.4981 24.9772H7.42805C3.37972 24.9772 1.68805 22.0839 3.64805 18.5489L7.28805 11.9922L10.7181 5.83219C12.7947 2.08719 16.2014 2.08719 18.2781 5.83219L21.7081 12.0039L25.3481 18.5605C27.3081 22.0955 25.6047 24.9889 21.5681 24.9889H14.4981V24.9772Z" stroke="#AF1F24" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector_3" d="M14.4922 19.834H14.5027" stroke="#AF1F24" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</g>
</svg>
